import { render, staticRenderFns } from "./GroupOneKidPDFPreview.vue?vue&type=template&id=37088257&scoped=true"
import script from "./GroupOneKidPDFPreview.vue?vue&type=script&lang=js"
export * from "./GroupOneKidPDFPreview.vue?vue&type=script&lang=js"
import style0 from "./GroupOneKidPDFPreview.vue?vue&type=style&index=0&id=37088257&lang=scss"
import style1 from "./GroupOneKidPDFPreview.vue?vue&type=style&index=1&id=37088257&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37088257",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37088257')) {
      api.createRecord('37088257', component.options)
    } else {
      api.reload('37088257', component.options)
    }
    module.hot.accept("./GroupOneKidPDFPreview.vue?vue&type=template&id=37088257&scoped=true", function () {
      api.rerender('37088257', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByGroup/GroupExcelTableDialog/GroupOneKidPDFPreview.vue"
export default component.exports